import { pdfjs } from "react-pdf";
// vite.config.js resolves "pdfjs-dist/" to the copy react-pdf depends on, so the worker always matches its API
import workerSrc from "pdfjs-dist/build/pdf.worker.min.mjs?url";

pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;
